import { apiClient, idempotentConfig, unwrap } from './client';
import type { ApiEnvelope, SimulationMode, SimulationRequest, SimulationView } from './types';

/**
 * Simulation / impact analysis (PS-2 publish-gate contract). MODE_1 = static impact (the only wired
 * mode); MODE_2..4 return `422 MODE_SUBSTRATE_UNAVAILABLE`. POST seals a reproducible ImpactReport
 * (content-addressed by reportHash); GET fetches it by id. The report often rides on the POST
 * response for MODE_1 (seconds, no execution) — callers poll GET only when it does not.
 */

const enc = (s: string) => encodeURIComponent(s);

/** POST /v1/simulations — run an impact analysis of a candidate draft version. */
export async function runSimulation(
  req: {
    flowId: string;
    versionId: number;
    championVersion?: number;
    mode?: SimulationMode;
    params?: Record<string, unknown>;
  },
  idemKey?: string,
): Promise<SimulationView> {
  const body: SimulationRequest = {
    flowId: req.flowId,
    versionId: req.versionId,
    championVersion: req.championVersion,
    mode: req.mode ?? 'MODE_1',
    params: req.params,
  };
  const { data } = await apiClient.post<ApiEnvelope<SimulationView>>(
    '/v1/simulations',
    body,
    idempotentConfig(idemKey),
  );
  return unwrap(data);
}

/** GET /v1/simulations/{id} — fetch a sealed ImpactReport by id (the report hash). */
export async function getSimulation(id: string): Promise<SimulationView> {
  const { data } = await apiClient.get<ApiEnvelope<SimulationView>>(`/v1/simulations/${enc(id)}`);
  return unwrap(data);
}
